<template>
  <div>
    <b-overlay :show="loading || loadingCreate" opacity="0.99">
      <v-data-table
        class="v-data-table-forms-semiology"
        :headers="headers"
        :items="semiology_forms"
        :search="search"
        :footer-props="{
          'items-per-page-options': [50, 75, 100],
          'items-per-page-text': 'Mostrar',
        }"
        @click:row="clickRowTable"
      />
    </b-overlay>
  </div>
</template>

<script>
import api from "../../../services/api";

export default {
  name: "Forms",
  created() {
    this.retrieve();
  },
  data() {
    return {
      search: "",
      semiology_forms: [],
      headers: [{ text: "NOME", value: "name" }],
      errors: [],
      loading: false,
    };
  },
  props: {
    resident_id: [Number, String],
    loadingCreate: [Boolean],
  },
  methods: {
    clickRowTable(item) {
      this.$emit("clickRowTable", item);
    },
    retrieve() {
      this.getFormsByProfile();
    },
    async getFormsByProfile() {
      try {
        this.loading = true;

        let { resident_id } = this;

        let params = { resident_id };

        const response = await api.get(
          "/rest-home/answer-semiology/forms/allowed-resident",
          { params }
        );
        const { error, errors, semiology_forms } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.semiology_forms = semiology_forms;
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<style>
.v-data-table-forms-semiology table tbody tr {
  cursor: pointer;
}
</style>